import React from "react";
import {
  Box
} from "@mui/material";
import CallToAction from '../call_to_action/CallToAction'
import CollegeServices from "./CollegeServices";
import CollegeCommits from "./CollegeCommits";
import Header from "./Header";
import StonyBrookUniversityPlayers from "./StonyBrookUniversityPlayers";

const College = () => {
  return (
    <Box id="college-page" sx={{pt: '64px'}}>
      <Header/>
      <CollegeServices/>
      <CollegeCommits/>
      <CallToAction/>
      <StonyBrookUniversityPlayers/>
    </Box>
  );
};

export default College;






